<script setup lang="ts">
import { computed } from 'vue'

interface Props {
  src?: string
  size?: number
  alt?: string
}

const { src = '', size = 40, alt = 'avatar' } = defineProps<Props>()

// 只接受非空字串當作圖片來源，避免空字串（會抓當前頁面）或物件（會變成 [object Object]）送出無效請求
const hasImage = computed(() => {
  return typeof src === 'string' && src.length > 0
})

const avatarSrc = computed(() => {
  return hasImage.value ? src : ''
})
</script>

<template>
  <el-avatar v-if="hasImage" :size="size" :src="avatarSrc" />
  <img
    v-else
    src="@/assets/image/default-avatar.png"
    :alt="alt"
    class="rounded-full object-cover"
    :style="{ width: `${size}px`, height: `${size}px` }"
  />
</template>

<style scoped></style>
